import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import SwiperCore, { A11y, Autoplay, Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'
// import 'swiper/css/scrollbar'
// import 'swiper/css/autoplay'

type ImageItem = {
    imageSrc: string;
};
interface PropsTypes {
    images: Array<ImageItem>;
}

export default function SwiperBanner(props: PropsTypes) {
    const { images } = props;
    const { useEffect } = useGlobal();

    let swiperInstance: any = null;

    const swiperStart = () => {
        swiperInstance?.autoplay?.start();
    };

    useEffect(() => {
        const ScrollMagic = (window as any).ScrollMagic;
        const ctl = new ScrollMagic.Controller();

        new ScrollMagic.Scene({
            triggerElement: '.SwiperBanner',
            offset: innerHeight / 2,
            triggerHook: 'onEnter',
            // duration: 100, //和滚动条绑定到一起,场景持续滚动距离为 800px
        })
            .on('enter', function (event: any) {
                swiperStart();
            })
            .addTo(ctl);
    }, []);

    return (
        <>
            <section className={`${css.componentRoot} SwiperBanner`}>
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    navigation={true}
                    // width={801}
                    pagination={{
                        clickable: true,
                    }}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    loop={true}
                    preloadImages={false}
                    lazy={true}
                    autoplay={false}
                    onInit={(swiper: any) => {
                        swiperInstance = swiper;
                    }}
                >
                    {images.map(({ imageSrc }, index) => {
                        return (
                            <SwiperSlide key={`${index}SwiperSlideItem`}>
                                <Image
                                    src={imageSrc}
                                    layout="fill"
                                    className="fullImgs"
                                    // alt={data.title ? data.title : data.synopsis}
                                />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </section>
        </>
    );
}
